module.exports = __webpack_public_path__ + "static/media/about.47d8b22d.jpg";